import Api from '@/api/config/_api_config.js'

export default {

    updateActiveRole(userId, roleId){
        const promise = Api().get('/users/'+userId+'/update_active_role?role_id='+roleId);
        return promise.then((response) => response.data)
    },

    getAuthUser(user_id){
        const promise = Api().get('users/'+user_id)
        return promise.then((response) => response.data)
    },

    getCouponAuthorizedUsers() {
        const promise = Api().get('/config/coupon/authorized-users')
        return promise.then((response) => response.data)
    },

     setResetPwdCode(data) {
        const promise = Api().post('/users/set-reset-password-code', data)
        return promise.then((response) => response.data)
    },

    changePassword(data) {
        const promise = Api().post('/users/set-new-password', data)
        return promise.then((response) => response.data)
    },

    selectListeCaissieres() {
        const promise = Api().get('/users/list/caissiers')
        return promise.then((response) => response.data)
    },
}